// import Admin from '../src/Admin/Components/Admin/Home';
// import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import "bootstrap/dist/css/bootstrap.min.css";
// import './App.css';

// import Login from './Login/Login';
// import Opening from './Admin/Components/Job Opening/Opening';
// import AdminLayout from './Admin/Components/AdminLayout/AdminLayout';
// import Department from './Admin/Components/Department/Department';
// import AddEmployee from './Admin/Components/Employee/AddEmployee';
// import RegisterationForm from './RegisterForm/RegisterationForm';
// import Attendance from './Admin/Components/Attendance/Attendance';
// import Lead from './Admin/Components/Leads/Lead';
// import AddDepartment from './Admin/Components/Department/AddDepartment';
// import AddJobs from './Admin/Components/Job Opening/AddJobs';
// import Employee from './Admin/Components/Employee/Employee';
// import Clients from './Admin/Components/Client/Clients';
// import Trainee from './Admin/Components/Traniee/Traniee';
// import RolesAndResponsibilities from './Admin/Components/Roles and Responsibility/RolesAndResponsibilities';
// import UpdateEmp from './Admin/Components/Employee/UpdateEmp';
// import ClientLead from './Admin/Components/ClientLeadData/ClientLeadData';
// import UpdateLeadClient from './Admin/Components/ClientLeadData/UpdateLeadClient';
// import EmployeeLayout from './Employee/Components/EmployeeLayout/EmployeeLayout';
// import EmployeeHome from './Employee/Components/EmployeeHome/EmployeeHome';
// import EmployeeAttendance from './Employee/Components/Attendance/EmployeeAttendance';
// import MoveToEmp from './Admin/Components/Employee/MoveToEmp';
// import LeavePage from './Employee/Components/Leaves/LeavePage';
// import SalaryPage from './Employee/Components/Salary/SalaryPage';
// import AddServices from './Admin/Components/Services/AddServices';
// import Service from './Admin/Components/Services/Service';
// import ViewClientPage from './Admin/Components/Client/ViewClientPage';
// import AddProject from './Admin/Components/Client/AddProject';
// import StatusDropdown from './Admin/Components/Leads/StatusDropdown';
// import ClientProjects from './Admin/Components/Client/ClientProjects';
// import Proposal from './Admin/Components/Client/Proposal';
// import ViewProjects from './Admin/Components/Client/ViewProjects';
// import ProjectDetails from './Admin/Components/Client/ProjectDetails';

// import InvoiceGenerator from './Admin/Components/Client/InvoiceGenerator';
// import UpdateDepartment from './Admin/Components/Department/UpdateDepartment';
// import UpdateService from './Admin/Components/Services/UpdateService';
// import PayPage from './Admin/Components/Client/PayPage';
// import PaymentSuccess from './Admin/Components/Client/PaymentSuccess';
// import ViewInvoice from './Admin/Components/Client/ViewInvoice';
// import TaskList from './Admin/Components/Task/TaskList';
// import AssignTask from './Admin/Components/Task/Task';
// import ProposalList from './Admin/Components/PurposalList/PurposalList';
// import InvoiceList from './Admin/Components/PurposalList/InvoicesList';
// import ReportsDashboard from './Admin/Components/Reports/ReportsDashboard';
// import NoticeBoard from './Admin/Components/NoticeBoard/NoticeBoard';
// import EmployeeTask from './Employee/Components/Task/EmployeeTask';
// import PerformancePage from './Employee/Components/Performance/PerformancePage';
// import SupportHelp from './Employee/Components/Support/SupportHelp';
// import EmployeeProfile from './Employee/Components/Profile/EmployeeProfile';
// import ViewLeadPage from './Admin/Components/Leads/ViewLeadPage';
// import ShowProject from './Admin/Components/Projects/Projects';
// import ProjectList from './Admin/Components/Projects/ProjectList';
// import UpdateProject from './Admin/Components/Projects/UpdateProject';
// import EditProposal from './Admin/Components/PurposalList/UpdateAndSentPurposal';
// import CompanyProjectsPage from './Admin/Components/Details/Details';
// import CompanyDetailsPage from './Admin/Components/Details/Details';
// import ViewEmployee from './Admin/Components/Employee/ViewEmployee';
// import ViewTrainee from './Admin/Components/Traniee/ViewTrainee';
// import EditInvoice from './Admin/Components/Client/EditInvoice';
// import ClientInvoicesList from './Admin/Components/Client/ClientInvoicesList';
// import ClientInvoicesListPage from './Admin/Components/Client/ClientInvoicesListPage';
// import ClientLogin from './ClientComponent/ClientLogin/ClientLogin';
// import ClientPasswordSetup from './ClientComponent/ClientLogin/ClientPasswordSetup';
// import CreateUserPage from './Admin/Components/CreateUser/CreateUser';
// import CreateUserAcc from './Admin/Components/CreateUser/CreateUserAcc';
// import AdminLogin from './Login/AdminLogin';
// import UpdateUserForm from './Admin/Components/CreateUser/UpdateUserForm';
// import ClientHome from './ClientComponent/Home/ClientHome';
// import ClientLayout from './ClientComponent/ClientLayout/ClientLayout';
// import AdminAllChats from './chat/AdminAllChats';
// import TaskView from './Admin/Components/Task/TaskView';
// import EmployeeTaskView from './Employee/Components/Task/EmployeeTaskView';
// import HRIS from './Admin/Components/HRIS/Hris';
// import ClientProjectDetail from './ClientComponent/Projects/ClientProjectDetail';
// import ClientProposals from './ClientComponent/Proposals/ClientProposals';
// import ClientProposalView from './ClientComponent/Proposals/ClientProposalView';
// import ClientProfile from './ClientComponent/Profile/ClientProfile';
// import ClientTasks from './ClientComponent/Task/ClientTasks';
// import ClientTaskView from './ClientComponent/Task/ClientTaskView';
// import ClientProjectsPage from './ClientComponent/Projects/ClientProjects';
// import AdminLeavePage from './Admin/Components/Leave/AdminLeavePage';
// import ForgetPassword from './Login/ForgetPassword';
// import ResetPassword from './Login/ResetPassword';
// import AdminSalaryPage from './Admin/Components/Salary/AdminSalaryPage';
// import EmployeeListPage from './Admin/Components/Task/EmployeeListPage';
// import EmployeeTaskPage from './Admin/Components/Task/EmployeeTaskPage';
// import TaskDetailsPage from './Admin/Components/Task/TaskDetailsPage';
// import EmployeeNotifications from './Employee/Components/EmployeeNotifications';

// function App() {
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path='/RegisterationForm' element={<RegisterationForm />} />
//           <Route path="/Login" element={<Login />} />
//           <Route path='/adminLogin' element={<AdminLogin />} />
//           {/* Admin Routes */}
//           <Route path="/admin" element={<AdminLayout />}>
//             <Route index element={<Admin />} />
//             <Route path="home" element={<Admin />} />
//             <Route path='HRIS' element={<HRIS/>}/>
//             <Route path="jobopening" element={<Opening />} />
//             <Route path='department' element={<Department />} />
//             <Route path="addService" element={<AddServices />} />
//             <Route path='addProject/:clientId' element={<AddProject />} />
//             <Route path='ClientProjects' element={<ClientProjects />} />
//             <Route path='addproposal' element={<Proposal />} />
//             <Route path='updateDepartment/:id' element={<UpdateDepartment />} />
//             <Route path='updateService/:id' element={<UpdateService />} />

//             <Route path='Service' element={<Service />} />
//             <Route path='addemployee' element={<AddEmployee />} />
//             <Route path='designation' />
//             <Route path="Attendance" element={<Attendance />} />
//             <Route path="leads" element={<Lead />} />
//             <Route path='dropdown' element={<StatusDropdown />} />
//             <Route path='addDepartment' element={<AddDepartment />} />
//             <Route path='addJobs' element={<AddJobs />} />
//             <Route path='Employee' element={<Employee />} />
//             <Route path='ViewEmployee/:employeeId' element={<ViewEmployee />} />
//             <Route path='ViewTrainee/:employeeId' element={<ViewTrainee />} />
//             <Route path='client' element={<Clients />} />
//             <Route path='leadPage/:leadId' element={<ViewLeadPage />} />
//             <Route path='viewclientpage/:leadId' element={<ViewClientPage />} />
//             <Route path='clientInvoicesList/:clientId' element={<ClientInvoicesListPage />} />
//             <Route path='projects' element={<ViewProjects />} />
//             <Route path='project/:clientId/:projectId' element={<ProjectDetails />} />
//             <Route path="invoice/:clientId" element={<InvoiceGenerator />} />
//             <Route path='PayPage/:invoiceId' element={<PayPage />} />
//             <Route path='viewInvoice/:id' element={<ViewInvoice />} />
//             {/* task api start */}
//             <Route path='TaskList' element={<TaskList />} />
//             <Route path='AdminLeavePage' element={<AdminLeavePage/>}/>


//             <Route path="/admin/task/assign" element={<AssignTask />} />
//             <Route path="/admin/task/:taskId" element={<TaskView />} />
//             <Route path="/admin/EmployeeTask" element={<EmployeeListPage/>}/>
//             <Route path="/admin/EmployeeTasks/:id" element={<EmployeeTaskPage/>}/>
//             <Route path='/admin/TaskDetails/:taskId' element={<TaskDetailsPage/>}/>



//             <Route path='PurposalList' element={<ProposalList />} />
//             <Route path='updateInvoice/:id' element={<EditInvoice />} />
//             <Route path='getAllprojects/edit/:id' element={<UpdateProject />} />
//             <Route path='InvoicesList' element={<InvoiceList />} />
//             <Route path='Reports' element={<ReportsDashboard />} />
//             <Route path='getAllprojects/:id' element={<ShowProject />} />
//             <Route path='getProjectList' element={<ProjectList />} />
//             <Route path='updateProposal/:id' element={<EditProposal />} />
//             <Route path='view-all-chats' element={<AdminAllChats />} />

//             <Route path='trainee' element={<Trainee />} />
//             <Route path='Roles' element={<RolesAndResponsibilities />} />
//             <Route path='upDateUder/:employeeId' element={<UpdateEmp />} />
//             <Route path='addClientLead' element={<ClientLead />} />
//             <Route path='moveToEmplyee/:employeeId' element={<MoveToEmp />} />
//             <Route path='NoticeBoard' element={<NoticeBoard />} />
//             <Route path='CreateUser' element={<CreateUserPage />} />
//             <Route path='createUserSAcc' element={<CreateUserAcc />} />
//             <Route path='updateUserPermission/:id' element={<UpdateUserForm />} />
//             <Route path='updateLeadClient/:leadId' element={<UpdateLeadClient />} />
//             <Route path='companyDetails' element={<CompanyDetailsPage />} />
//             <Route path='AdminSalaryPage' element={<AdminSalaryPage/>}/>
//           </Route>
//           {/* Employee Routes */}
//            <Route path='forgot-password' element={<ForgetPassword/>}/>
//            <Route path='/reset-password/:token' element={<ResetPassword/>}/>
           
//           <Route path='employee' element={<EmployeeLayout />}>
//             <Route index element={<EmployeeHome />} />
//             <Route path='employeeattendance' element={<EmployeeAttendance />} />
           
//             <Route path='LeavePage' element={<LeavePage />} />
//             <Route path='salaryPage' element={<SalaryPage />} />
//             <Route path='employeeTask' element={<EmployeeTask />} />
//             <Route path='employeeNotification' element={<EmployeeNotifications/>}/>
//             <Route path='performance' element={<PerformancePage />} />
//             <Route path='supportHelp' element={<SupportHelp />} />
//             <Route path='profile' element={<EmployeeProfile />} />
//             <Route path='TaskView/:taskId' element={<EmployeeTaskView/>}/>
//           </Route>
//           <Route path="client" element={<ClientLayout />}>
//             <Route index element={<ClientHome />} />
//             <Route path="ClientPage" element={<ClientLogin />} />
//             <Route path="CreatePassword" element={<ClientPasswordSetup />} />
//             <Route path='projects' element={<ClientProjectsPage/>}/>
//             <Route path='project/:projectId' element={<ClientProjectDetail/>}/>
//             <Route path='proposals' element={<ClientProposals/>}/>
//             <Route path='proposal/:proposalId' element={<ClientProposalView/>}/>
//             <Route path='profile' element={<ClientProfile/>}/>
//             <Route path='tasks' element={<ClientTasks/>}/>
//             <Route path='task/:taskId' element={<ClientTaskView/>}/>

//           </Route>



//           <Route path="/payment/success" element={<PaymentSuccess />} />
//         </Routes>

//       </BrowserRouter>

//     </div>
//   );
// }

// export default App;

import Admin from '../src/Admin/Components/Admin/Home';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';


import Login from './Login/Login';
import Opening from './Admin/Components/Job Opening/Opening';
import AdminLayout from './Admin/Components/AdminLayout/AdminLayout';
import Department from './Admin/Components/Department/Department';
import AddEmployee from './Admin/Components/Employee/AddEmployee';
import RegisterationForm from './RegisterForm/RegisterationForm';
import Attendance from './Admin/Components/Attendance/Attendance';
import Lead from './Admin/Components/Leads/Lead';
import AddDepartment from './Admin/Components/Department/AddDepartment';
import AddJobs from './Admin/Components/Job Opening/AddJobs';
import Employee from './Admin/Components/Employee/Employee';
import Clients from './Admin/Components/Client/Clients';
import Trainee from './Admin/Components/Traniee/Traniee';
import RolesAndResponsibilities from './Admin/Components/Roles and Responsibility/RolesAndResponsibilities';
import UpdateEmp from './Admin/Components/Employee/UpdateEmp';
import ClientLead from './Admin/Components/ClientLeadData/ClientLeadData';
import UpdateLeadClient from './Admin/Components/ClientLeadData/UpdateLeadClient';
import EmployeeLayout from './Employee/Components/EmployeeLayout/EmployeeLayout';
import EmployeeHome from './Employee/Components/EmployeeHome/EmployeeHome';
import EmployeeAttendance from './Employee/Components/Attendance/EmployeeAttendance';
import MoveToEmp from './Admin/Components/Employee/MoveToEmp';
import LeavePage from './Employee/Components/Leaves/LeavePage';
import SalaryPage from './Employee/Components/Salary/SalaryPage';
import AddServices from './Admin/Components/Services/AddServices';
import Service from './Admin/Components/Services/Service';
import ViewClientPage from './Admin/Components/Client/ViewClientPage';
import AddProject from './Admin/Components/Client/AddProject';
import StatusDropdown from './Admin/Components/Leads/StatusDropdown';
import ClientProjects from './Admin/Components/Client/ClientProjects';
import Proposal from './Admin/Components/Client/Proposal';
import ViewProjects from './Admin/Components/Client/ViewProjects';
import ProjectDetails from './Admin/Components/Client/ProjectDetails';

import InvoiceGenerator from './Admin/Components/Client/InvoiceGenerator';
import ManualInvoice from './Admin/Components/Client/ManualInvoice';
import UpdateDepartment from './Admin/Components/Department/UpdateDepartment';
import UpdateService from './Admin/Components/Services/UpdateService';
import PayPage from './Admin/Components/Client/PayPage';
import PaymentSuccess from './Admin/Components/Client/PaymentSuccess';
import ViewInvoice from './Admin/Components/Client/ViewInvoice';
import TaskList from './Admin/Components/Task/TaskList';
import AssignTask from './Admin/Components/Task/Task';
import ProposalList from './Admin/Components/PurposalList/PurposalList';
import InvoiceList from './Admin/Components/PurposalList/InvoicesList';
import ReportsDashboard from './Admin/Components/Reports/ReportsDashboard';
import NoticeBoard from './Admin/Components/NoticeBoard/NoticeBoard';
import EmployeeTask from './Employee/Components/Task/EmployeeTask';
import PerformancePage from './Employee/Components/Performance/PerformancePage';
import SupportHelp from './Employee/Components/Support/SupportHelp';
import EmployeeProfile from './Employee/Components/Profile/EmployeeProfile';
import ViewLeadPage from './Admin/Components/Leads/ViewLeadPage';
import ShowProject from './Admin/Components/Projects/Projects';
import ProjectList from './Admin/Components/Projects/ProjectList';
import UpdateProject from './Admin/Components/Projects/UpdateProject';
import EditProposal from './Admin/Components/PurposalList/UpdateAndSentPurposal';
import CompanyProjectsPage from './Admin/Components/Details/Details';
import CompanyDetailsPage from './Admin/Components/Details/Details';
import Accounts from './Admin/Components/Accounts/Accounts';
import AddBankAccount from './Admin/Components/Accounts/AddBankAccount';
import Income from './Admin/Components/Accounts/Income';
import Expenses from './Admin/Components/Accounts/Expenses';
import ExpenseCategory from './Admin/Components/Accounts/ExpenseCategory';
import ProfitLoss from './Admin/Components/Accounts/ProfitLoss';
import Domain from './Admin/Components/Details/Domain';
import Subscriptions from './Admin/Components/Details/Subscriptions';
import ViewEmployee from './Admin/Components/Employee/ViewEmployee';
import ViewTrainee from './Admin/Components/Traniee/ViewTrainee';
import EditInvoice from './Admin/Components/Client/EditInvoice';
import ClientInvoicesList from './Admin/Components/Client/ClientInvoicesList';
import ClientInvoicesListPage from './Admin/Components/Client/ClientInvoicesListPage';
import ClientLogin from './ClientComponent/ClientLogin/ClientLogin';
import ClientPasswordSetup from './ClientComponent/ClientLogin/ClientPasswordSetup';
import CreateUserPage from './Admin/Components/CreateUser/CreateUser';
import CreateUserAcc from './Admin/Components/CreateUser/CreateUserAcc';
import AdminLogin from './Login/AdminLogin';
import UpdateUserForm from './Admin/Components/CreateUser/UpdateUserForm';
import ClientHome from './ClientComponent/Home/ClientHome';
import ClientLayout from './ClientComponent/ClientLayout/ClientLayout';
import AdminAllChats from './chat/AdminAllChats';
import TaskView from './Admin/Components/Task/TaskView';
import EmployeeTaskView from './Employee/Components/Task/EmployeeTaskView';
import HRIS from './Admin/Components/HRIS/Hris';
import ClientProjectDetail from './ClientComponent/Projects/ClientProjectDetail';
import ClientProposals from './ClientComponent/Proposals/ClientProposals';
import ClientProposalView from './ClientComponent/Proposals/ClientProposalView';
import ClientProfile from './ClientComponent/Profile/ClientProfile';
import ClientTasks from './ClientComponent/Task/ClientTasks';
import ClientTaskView from './ClientComponent/Task/ClientTaskView';
import ClientProjectsPage from './ClientComponent/Projects/ClientProjects';
import AdminLeavePage from './Admin/Components/Leave/AdminLeavePage';
import ForgetPassword from './Login/ForgetPassword';
import ResetPassword from './Login/ResetPassword';
import AdminSalaryPage from './Admin/Components/Salary/AdminSalaryPage';
import EmployeeListPage from './Admin/Components/Task/EmployeeListPage';
import EmployeeTaskPage from './Admin/Components/Task/EmployeeTaskPage';
import TaskDetailsPage from './Admin/Components/Task/TaskDetailsPage';
import EmployeeNotifications from './Employee/Components/EmployeeNotifications';
import Designation from './Admin/Components/Designation/Designation';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path='/RegisterationForm' element={<RegisterationForm />} />
          <Route path="/Login" element={<Login />} />
          <Route path='/adminLogin' element={<AdminLogin />} />
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Admin />} />
            <Route path="home" element={<Admin />} />
            <Route path='HRIS' element={<HRIS/>}/>
            <Route path="jobopening" element={<Opening />} />
            <Route path='department' element={<Department />} />
            <Route path="addService" element={<AddServices />} />
            <Route path='addProject/:clientId' element={<AddProject />} />
            <Route path='ClientProjects/:clientId?' element={<ClientProjects />} />
            <Route path='addproposal' element={<Proposal />} />
            <Route path='updateDepartment/:id' element={<UpdateDepartment />} />
            <Route path='updateService/:id' element={<UpdateService />} />

            <Route path='Service' element={<Service />} />
            <Route path='addemployee' element={<AddEmployee />} />
            <Route path='designation' element={<Designation />} />
            <Route path="Attendance" element={<Attendance />} />
            <Route path="leads" element={<Lead />} />
            <Route path='dropdown' element={<StatusDropdown />} />
            <Route path='addDepartment' element={<AddDepartment />} />
            <Route path='addJobs' element={<AddJobs />} />
            <Route path='Employee' element={<Employee />} />
            <Route path='ViewEmployee/:employeeId' element={<ViewEmployee />} />
            <Route path='ViewTrainee/:employeeId' element={<ViewTrainee />} />
            <Route path='client' element={<Clients />} />
            <Route path='leadPage/:leadId' element={<ViewLeadPage />} />
            <Route path='viewclientpage/:leadId' element={<ViewClientPage />} />
            <Route path='clientInvoicesList/:clientId' element={<ClientInvoicesListPage />} />
            <Route path='projects' element={<ViewProjects />} />
            <Route path='project/:clientId/:projectId' element={<ProjectDetails />} />
            <Route path="invoice/:clientId" element={<InvoiceGenerator />} />
            <Route path="manual-invoice" element={<ManualInvoice />} />
            <Route path='PayPage/:invoiceId' element={<PayPage />} />
            <Route path='viewInvoice/:id' element={<ViewInvoice />} />
            {/* task api start */}
            <Route path='TaskList' element={<TaskList />} />
            <Route path='AdminLeavePage' element={<AdminLeavePage/>}/>


            <Route path="/admin/task/assign" element={<AssignTask />} />
            <Route path="/admin/task/:taskId" element={<TaskView />} />
            <Route path="/admin/EmployeeTask" element={<EmployeeListPage/>}/>
            <Route path="/admin/EmployeeTasks/:id" element={<EmployeeTaskPage/>}/>
            <Route path='/admin/TaskDetails/:taskId' element={<TaskDetailsPage/>}/>



            <Route path='PurposalList' element={<ProposalList />} />
            <Route path='updateInvoice/:id' element={<EditInvoice />} />
            <Route path='getAllprojects/edit/:id' element={<UpdateProject />} />
            <Route path='InvoicesList' element={<InvoiceList />} />
            <Route path='Reports' element={<ReportsDashboard />} />
            <Route path='getAllprojects/:id' element={<ShowProject />} />
            <Route path='getProjectList' element={<ProjectList />} />
            <Route path='updateProposal/:id' element={<EditProposal />} />
            <Route path='view-all-chats' element={<AdminAllChats />} />

            <Route path='trainee' element={<Trainee />} />
            <Route path='Roles' element={<RolesAndResponsibilities />} />
            <Route path='upDateUder/:employeeId' element={<UpdateEmp />} />
            <Route path='addClientLead' element={<ClientLead />} />
            <Route path='moveToEmplyee/:employeeId' element={<MoveToEmp />} />
            <Route path='NoticeBoard' element={<NoticeBoard />} />
            <Route path='CreateUser' element={<CreateUserPage />} />
            <Route path='createUserSAcc' element={<CreateUserAcc />} />
            <Route path='updateUserPermission/:id' element={<UpdateUserForm />} />
            <Route path='updateLeadClient/:leadId' element={<UpdateLeadClient />} />
            <Route path='companyDetails' element={<CompanyDetailsPage />} />
            <Route path='accounts' element={<Accounts />} />
            <Route path='add-bank-account' element={<AddBankAccount />} />
            <Route path='income' element={<Income />} />
            <Route path='expenses' element={<Expenses />} />
            <Route path='expense-category' element={<ExpenseCategory />} />
            <Route path='profit-loss' element={<ProfitLoss />} />
            <Route path='domain' element={<Domain type="domain" />} />
            <Route path='hosting' element={<Domain type="hosting" />} />
            <Route path='email' element={<Domain type="email" />} />
            <Route path='subscriptions' element={<Subscriptions />} />
            <Route path='AdminSalaryPage' element={<AdminSalaryPage/>}/>
          </Route>
          {/* Employee Routes */}
           <Route path='forgot-password' element={<ForgetPassword/>}/>
           <Route path='/reset-password/:token' element={<ResetPassword/>}/>
           
          <Route path='employee' element={<EmployeeLayout />}>
            <Route index element={<EmployeeHome />} />
            <Route path='employeeattendance' element={<EmployeeAttendance />} />
           
            <Route path='LeavePage' element={<LeavePage />} />
            <Route path='salaryPage' element={<SalaryPage />} />
            <Route path='employeeTask' element={<EmployeeTask />} />
            <Route path='employeeNotification' element={<EmployeeNotifications/>}/>
            <Route path='performance' element={<PerformancePage />} />
            <Route path='supportHelp' element={<SupportHelp />} />
            <Route path='profile' element={<EmployeeProfile />} />
            <Route path='TaskView/:taskId' element={<EmployeeTaskView/>}/>
          </Route>
          <Route path="client" element={<ClientLayout />}>
            <Route index element={<ClientHome />} />
            <Route path="ClientPage" element={<ClientLogin />} />
            <Route path="CreatePassword" element={<ClientPasswordSetup />} />
            <Route path='projects' element={<ClientProjectsPage/>}/>
            <Route path='project/:projectId' element={<ClientProjectDetail/>}/>
            <Route path='proposals' element={<ClientProposals/>}/>
            <Route path='proposal/:proposalId' element={<ClientProposalView/>}/>
            <Route path='profile' element={<ClientProfile/>}/>
            <Route path='tasks' element={<ClientTasks/>}/>
            <Route path='task/:taskId' element={<ClientTaskView/>}/>

          </Route>



          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

      </BrowserRouter>

    </div>
  );
}

export default App;
